import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControlName, ValidationErrors, Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { COMMA, ENTER } from '@angular/cdk/keycodes';

import { ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AppoinmentserviceService } from './appoinmentservice.service';
import { Notification } from '../../../core/Notifications/Notification';
import { forEachRight, values } from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import { DialogContentExample1Component } from '../dialog-content-example1/dialog-content-example1.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ShowdoctorComponent } from '../showdoctor/showdoctor.component';
import { ShowhospitalComponent } from '../showhospital/showhospital.component';
import { DialogdoctorComponent } from '../dialogdoctor/dialogdoctor.component';


@Component({
  selector: 'app-add-appoinments',
  templateUrl: './add-appoinments.component.html',
  styleUrls: ['./add-appoinments.component.scss']
})

export class AddAppoinmentsComponent implements OnInit {
  doctors: any;
  complaint: any;
  complaints: any;
  underMedication_DTL: any;
  diseases: any;
  medication: any;
  medical: any;
  symptoms: any;
  appoinmentForm: FormGroup;
  private json: any;
  private filterJson: any;
  i = 0;
  result: any;
  toppings: any;
  ClinicalDiscipline: any;
  appoinment: any;
  doctordd: any;

    minDate:any= new Date();

  testing = [{ smst_Id: 1, smst_Code: 'SYM1', smst_Name: 'Fever' }, { smst_Id: 2, smst_Code: 'SYM1', smst_Name: 'Fever' }]
  userTestStatus: { smst_Id: string, smst_Code: string, smst_Name: string }[];
  allergy: any;
  test: any;

  constructor(public dialog: MatDialog, private formBuilder: FormBuilder, private AppoinmentserviceService: AppoinmentserviceService, private router: Router,
    private notify: Notification) {
    this.appoinmentForm = this.formBuilder.group({
      'complaint': ['',Validators.required],
      'underMedication_DTL': ['',Validators.required],
      // 'medical': ['',Validators.required],
      // 'symptoms': ['',Validators.required],
      // 'diseasesDtl': ['',Validators.required],
      'allergySigns_DTL': ['',Validators.required],
      // 'Weight': ['', [Validators.pattern("^[0-9]*$")]],
      // 'Height': ['', [Validators.pattern("^[0-9]*$")]],
      'select_day': ['',Validators.required],
      'select_FrmTime': ['',Validators.required],
      'select_toTime': ['',Validators.required],
      'Appt_DO_Id_FK': [''],
      // 'bmi':[''],
    },
      {
        validators: this.toTimeValidator.bind(this),
    });

  }

  ngOnInit(): void {
    this.get_doctors()
    this.get_complaint()
    this.get_diseases()
    this.Get_All_Medication()
    // this.get_symptoms()
    this.get_Discipline()
    this.get_Allergy()
    // const fromTimeControl = this.appoinmentForm.get('select_FrmTime');
    // const toTimeControl = this.appoinmentForm.get('select_toTime');
    // fromTimeControl.setValidators(this.fromTimeValidator.bind(this, toTimeControl));
    // toTimeControl.setValidators(this.toTimeValidator.bind(this, fromTimeControl));
  }



  select_weight: any;
  bmi: any;
  Get_bmi(select_height: any, event: any) {
    this.select_weight = event.target.value;
    this.bmi = this.select_weight / Math.pow(select_height / 100, 2);
    this.bmi = parseFloat(this.bmi).toFixed(2);
    console.log("BMI value is ", this.bmi);
    this.appoinmentForm.controls['bmi'].setValue(this.bmi);


  }

  toTimeValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const fromTime = control.get('select_FrmTime').value;
    const toTime = control.get('select_toTime').value;

    if (fromTime && toTime) {
      const fromTimeParts = fromTime.split(':');
      const toTimeParts = toTime.split(':');

      const fromTimeHours = parseInt(fromTimeParts[0], 10);
      const fromTimeMinutes = parseInt(fromTimeParts[1], 10);

      const toTimeHours = parseInt(toTimeParts[0], 10);
      const toTimeMinutes = parseInt(toTimeParts[1], 10);

      if (
        fromTimeHours > toTimeHours ||
        (fromTimeHours === toTimeHours && fromTimeMinutes >= toTimeMinutes)
      ) {
        this.notify.errorsmsg("Invalid time selection, please choose a time from the present or future.")
        return { fromTimeGreaterThanToTime: true };
      }
    }

    return null;
  }
  //Complaint
  //toppingsControl = new FormControl([]);
  // toppingList: string[] = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato'];

  onToppingRemoved(topping: string) {
    const toppings = this.appoinmentForm.value.complaint;

 
    this.removeFirst(toppings, topping);

    this.appoinmentForm.controls['complaint'].setValue(toppings); 

    this.appoinmentForm.controls['topping'].setValue(topping);// To trigger change detection
  }

  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }
  // onComplaintsSelectionChange(): void {
  //   const selectedOption = this.appoinmentForm.value.underMedication_DTL;


  //   const noneOptionSelected = selectedOption && selectedOption.some((item: any) => item.medic_name === "Other than Listed(ಪಟ್ಟಿ ಮಾಡಲಾದ ಹೊರತುಪಡಿಸಿ)");

  //   if (noneOptionSelected) {
  //     //this.fixappointment.get('allergySigns_DTL').setValue(['None']);
  //     this.isOptionDisableds(noneOptionSelected);
  //   }
  // }

  isOptionDisabled3(option: any): boolean {
    const selectedOption = this.appoinmentForm.value.complaint;
    if (selectedOption == '') {
      return;
    }
    const noneOptionSelected = selectedOption && selectedOption.some((item: any) => item.cmst_Name === "Other than Listed(ಪಟ್ಟಿ ಮಾಡಲಾದ ಹೊರತುಪಡಿಸಿ)");
    if (noneOptionSelected) {
      return option.cmst_Name != "Other than Listed(ಪಟ್ಟಿ ಮಾಡಲಾದ ಹೊರತುಪಡಿಸಿ)" && noneOptionSelected;
    }
    else {
      return option.cmst_Name == "Other than Listed(ಪಟ್ಟಿ ಮಾಡಲಾದ ಹೊರತುಪಡಿಸಿ)"
    }


  }
  isOptionDisableds(option: any): boolean {
    const selectedOption = this.appoinmentForm.value.underMedication_DTL;
  
    // If no option is selected, all options are enabled
    if (!selectedOption || selectedOption.length === 0) {
      return false;
    }
  
    const noneOptionSelected = selectedOption.some((item: any) => item.medic_name === "Other than Listed(ಪಟ್ಟಿ ಮಾಡಲಾದ ಹೊರತುಪಡಿಸಿ)");
  
    // If "Other than Listed" option is selected, disable options except "Other than Listed"
    if (noneOptionSelected) {
      return option.medic_name !== "Other than Listed(ಪಟ್ಟಿ ಮಾಡಲಾದ ಹೊರತುಪಡಿಸಿ)";
    } else {
      // If other options are selected, disable "Other than Listed"
      return option.medic_name === "Other than Listed(ಪಟ್ಟಿ ಮಾಡಲಾದ ಹೊರತುಪಡಿಸಿ)";
    }
  }
  
  //symptoms
  // toppingsControl1 = new FormControl([]);
  toppingList1: string[] = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato'];

  onToppingRemoved1(topping: any) {

    const toppings = this.appoinmentForm.value.symptoms;
    this.removeFirst1(toppings, topping);
    this.appoinmentForm.controls['symptoms'].setValue(toppings);
  }


  private removeFirst1<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }
  
  onSymptomsSelectionChange(): void {
    const selectedOption = this.appoinmentForm.value.symptoms;


    const noneOptionSelected = selectedOption && selectedOption.some((item: any) => item.smst_Name === "Other than Listed(ಪಟ್ಟಿ ಮಾಡಲಾದ ಹೊರತುಪಡಿಸಿ)");

    if (noneOptionSelected) {
      //this.fixappointment.get('allergySigns_DTL').setValue(['None']);
      this.isOptionDisabled2(noneOptionSelected);
    }
  }

  isOptionDisabled2(option: any): boolean {
    const selectedOption = this.appoinmentForm.value.symptoms;
    if (selectedOption == '') {
      return;
    }
    const noneOptionSelected = selectedOption && selectedOption.some((item: any) => item.smst_Name === "Other than Listed(ಪಟ್ಟಿ ಮಾಡಲಾದ ಹೊರತುಪಡಿಸಿ)");
    if (noneOptionSelected) {
      return option.smst_Name != "Other than Listed(ಪಟ್ಟಿ ಮಾಡಲಾದ ಹೊರತುಪಡಿಸಿ)" && noneOptionSelected;
    }
    else {
      return option.smst_Name == "Other than Listed(ಪಟ್ಟಿ ಮಾಡಲಾದ ಹೊರತುಪಡಿಸಿ)"
    }


  }

  //diseases
  toppingList2: string[] = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato'];

  onToppingRemoved2(topping: string) {
    const toppings = this.appoinmentForm.value.allergySigns_DTL;
    this.removeFirst2(toppings, topping);
    this.appoinmentForm.controls['allergySigns_DTL'].setValue(toppings); // To trigger change detection
  }
  private removeFirst3<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }

  onPresentillnessSelectionChange(): void {
    const selectedOption = this.appoinmentForm.value.diseasesDtl;


    const noneOptionSelected = selectedOption && selectedOption.some((item: any) => item.diseases_Name === "Other than Listed");

    if (noneOptionSelected) {
      //this.fixappointment.get('allergySigns_DTL').setValue(['None']);
      this.isOptionDisabled1(noneOptionSelected);
    }
  }

  isOptionDisabled1(option: any): boolean {
    const selectedOption = this.appoinmentForm.value.diseasesDtl;
    if (selectedOption == '') {
      return;
    }
    const noneOptionSelected = selectedOption && selectedOption.some((item: any) => item.diseases_Name === "Other than Listed");
    if (noneOptionSelected) {
      return option.diseases_Name != "Other than Listed" && noneOptionSelected;
    }
    else {
      return option.diseases_Name == "Other than Listed"
    }


  }
//Allergy
onToppingRemoved3(topping: string) {
    const toppings = this.appoinmentForm.value.underMedication_DTL;
    this.removeFirst2(toppings, topping);
    this.appoinmentForm.controls['underMedication_DTL'].setValue(toppings); // To trigger change detection
  }

  private removeFirst2<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }
  onToppingRemoved4(topping: string) {
    const toppingsss = this.appoinmentForm.value.underMedication_DTL;
    this.removeFirst4(toppingsss, topping);
    this.appoinmentForm.controls['underMedication_DTL'].setValue(topping); // To trigger change detection
  }

  private removeFirst4<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }

  onAllergySelectionChange(): void {
    const selectedOption = this.appoinmentForm.value.allergySigns_DTL;
    
    
    const noneOptionSelected = selectedOption && selectedOption.some((item: any) => item.al_Name === "Others");

    if (noneOptionSelected) {
      //this.fixappointment.get('allergySigns_DTL').setValue(['None']);
       this.isOptionDisabled(noneOptionSelected);
    }
  }

  isOptionDisabled(option: any): boolean {
    const selectedOption = this.appoinmentForm.value.allergySigns_DTL;
    if(selectedOption=='')
    {
      return;
    }
    const noneOptionSelected = selectedOption && selectedOption.some((item: any) => item.al_Name === "Others");
    if(noneOptionSelected){
      return option.al_Name != "Others" && noneOptionSelected;
    }
    else{
      return option.al_Name =="Others" 
    }
    

  }
  onComplaintsSelectionChange(): void {
    const selectedOption = this.appoinmentForm.value.underMedication_DTL;


    const noneOptionSelected = selectedOption && selectedOption.some((item: any) => item.al_Name === "Other than Listed(ಪಟ್ಟಿ ಮಾಡಲಾದ ಹೊರತುಪಡಿಸಿ)");

    if (noneOptionSelected) {
      //this.fixappointment.get('allergySigns_DTL').setValue(['None']);
      this.isDisabled(noneOptionSelected);
    }
  }

  isDisabled(option: any): boolean {
    const selectedOption = this.appoinmentForm.value.underMedication_DTL;
    if(selectedOption=='')
    {
      return;
    }
    const noneOptionSelected = selectedOption && selectedOption.some((item: any) => item.medic_name === "Other than Listed");
    if(noneOptionSelected){
      return option.medic_name != "Other than Listed" && noneOptionSelected;
    }
    else{
      return option.medic_name =="Other than Listed" 
    }
    
  }


  
  


  
  nameValidators(control: any): { [key: string]: boolean } {
    const nameRegexp: RegExp = /[!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?/\s/g,''/a-zA-Z]/;
    // const spaceexp: RegExp =/[/\s/g, '']/

    if (control.value && nameRegexp.test(control.value)) {
      return { invalidName: true };
    }
  }

  get f(){
    return this.appoinmentForm.controls;
  }


  saveForm() {
    console.log(this.appoinment);

    if(this.appoinmentForm == null)
      {
alert('error')
        
      }
    // if (!this.appoinmentForm.value.symptoms || this.appoinmentForm.value.symptoms.length === 0) {
    //   this.appoinmentForm.value.symptoms = []; // Set symptoms to an empty array
    // }
    
    // if (!this.appoinmentForm.value.diseasesDtl || this.appoinmentForm.value.diseasesDtl.length === 0) {
    //   this.appoinmentForm.value.diseasesDtl = [{ diseases_Id: 0, diseases_Name: 'Default Present Illness' }];
    // }
    
    // if (!this.appoinmentForm.value.medical || this.appoinmentForm.value.medical.length === 0) {
    //   this.appoinmentForm.value.medical = [{ medical_Id: 0, medical_Name: 'Default medical' }];
    // }

  
    console.log('Form data is', this.appoinmentForm.value);
    this.AppoinmentserviceService.Post_appoinment(this.appoinmentForm.value).subscribe((data: any) => {
      this.appoinment = data
      this.openDialog();

    })

    this.router.navigate(["/base/patient/Appoinment"]);
    
    this.notify.successmsg("Appoinment" + " fixed Successfully.");
    this.notify.errorsmsg("Appoinment"+"not fixed")
  }

  openDialog() {
    const dialogRef = this.dialog.open(DialogContentExample1Component);
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
  resetForm() {
    this.appoinmentForm.reset();
  }

  get_doctors() {
    this.AppoinmentserviceService.get_doctors()
      .subscribe((data) => {
        this.doctors = data
        console.log(this.doctors)
      })
  }

  get_complaint() {
    this.AppoinmentserviceService.get_complaint()
      .subscribe((data) => {
        console.log('com')
        this.complaint = data
        console.log(this.complaints)
      })
  }
  // Get_All_Medication() {
  //   this.AppoinmentserviceService.Get_All_Medication()
  //     .subscribe((data) => {
  //       console.log('com')
  //       this.complaint = data
  //       console.log(this.complaint)
  //     })
  // }
  get_diseases() {
    this.AppoinmentserviceService.get_diseases()
      .subscribe((data) => {
        this.diseases = data
        console.log('dis')
        console.log(this.diseases)
      })
  }

  // get_symptoms() {
  //   this.AppoinmentserviceService.get_symptoms()
  //     .subscribe((data) => {
  //       this.symptoms = data
  //       console.log('sys')
  //       console.log(this.symptoms)
  //     })
  // }
 
   Get_All_Medication() {
    this.AppoinmentserviceService.Get_All_Medication()
      .subscribe((data) => {
        console.log('com')
        this.underMedication_DTL = data
        console.log(this.underMedication_DTL)
      })
 }

  get_Allergy() {
    this.AppoinmentserviceService.get_allergy()
      .subscribe((data) => {
        this.allergy = data
      })
  }

  get_Discipline() {
    this.AppoinmentserviceService.get_Discipline()
      .subscribe((data) => {
        this.ClinicalDiscipline = data
        console.log(this.ClinicalDiscipline)
      })
  }

  get_doctordd() {
    this.AppoinmentserviceService.get_doctordd()
      .subscribe((data) => {
        this.doctordd = data
        console.log(this.doctordd)
      })
  }

  showdoctr() {
    const dialogRef = this.dialog.open(ShowdoctorComponent,
      {
        height: '65%',
        width: '65%',
      });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if (result != undefined) {
        this.test = result.dO_Name;
        this.appoinmentForm.controls['Appt_DO_Id_FK'].setValue(result.dO_Id);
      }
      //   setTimeout(() => {
      //     window.location.reload();
      // }, 2000);
    });
  }

  showhosptl() {
    const dialogRef = this.dialog.open(ShowhospitalComponent,
      {
        height: '65%',
        width: '65%',
      });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if (result != undefined) {
        this.test = result.dO_Name;
        this.appoinmentForm.controls['Appt_DO_Id_FK'].setValue(result.dO_Id);
      }
      //   setTimeout(() => {
      //     window.location.reload();
      // }, 2000);
    });
  }


  doctor() {
    if (!this.appoinmentForm.valid) {
      // Mark all form controls as touched to trigger the validation errors
      this.markAllFieldsAsTouched(this.appoinmentForm);
 
    }
   
  
    const dialogRef = this.dialog.open(DialogdoctorComponent,
      {
        height: '45%',
        width: '55%',
        data:this.appoinmentForm.value,
      });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      //   setTimeout(() => {
      //     window.location.reload();
      // }, 2000);
    });
  
    

}
  markAllFieldsAsTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markAllFieldsAsTouched(control);
      }
    });
  }

}

